<template>
	<div id="app"><router-view v-if="isRouter"></router-view></div>
</template>

<script>
import './base/base.css';
export default {
	name: 'app',
	provide() {
		return {
			reload: this.reload
		};
	},
	data() {
		return {
			isRouter: true
		};
	},
	
	methods: {
		reload() {
			this.isRouter = false;
			this.$nextTick(function() {
				this.isRouter = true;
			});
		}
	}
};
</script>

<style>
        ::-webkit-scrollbar {
            /*滚动条整体样式*/
            width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
            height: 10px;
        }
        ::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            border-radius: 10px;
            -webkit-box-shadow: inset 0 0 5px #f1f1f1;
            background: #cdcdcd;
        }
        ::-webkit-scrollbar-track {
            /*滚动条里面轨道*/
            -webkit-box-shadow: inset 0 0 5px #f1f1f1;
            border-radius: 10px;
            background: #f6f6f6;
        }
</style>
